define([
	'jquery',
	'responsive',
	'common',
    'erv_tracking',
	'erv_validation_extensions',
	'erv_translate',
	'modulerepository',
	'polyfill'
], function($,
    ERVResponsive,
    ERVCommon,
    ERVTracking,
    ERVValidationExtensions,
    ERVTranslate,
	ModuleRepository,
	Polyfill
) {

    const CHUNKS = [
		'adhoc_widget',
		'booking_guide',
		'claims',
        'mypages',
    ]


	const resolveChunk = (chunkName) => {

        const callback = (moduleName) => {
            var requiredClass = new (moduleName);
            requiredClass.init();
        }

        switch(chunkName) {
        case 'adhoc_widget':
				return require(['adhoc_widget'], callback);
        case 'booking_guide':
				return require(['booking_guide'], callback);
        case 'claims':
            return require(['claims'], callback);
        case 'mypages':
            return require(['mypages'], callback);
        default:
            return false;
		}
    }


    var $ervBody = $('#erv-body');

	var ervValidation = new ERVValidationExtensions();
	ervValidation.init();

	var common = new ERVCommon();
		common.init();

        var translate = new ERVTranslate();
	translate.init();

	var ervTracking = new ERVTracking();
	ervTracking.init();

	var responsive = new ERVResponsive();
		responsive.init();

	if ($ervBody.find('[data-js="search-suggestions"]').length) {
		require(['erv_autosuggest'], function (ervAutosuggest) { ervAutosuggest.default.init(); });
    }

    if ($ervBody.find('.flex-nav').length) {
		require(['flexmenu'], function (moduleName) { var requiredClass = new (moduleName); requiredClass.init('.flex-nav'); });
	}

	if ($ervBody.find('.tabs').length) {
		require(['tabs'], function (moduleName) { var requiredClass = new (moduleName); requiredClass.init(); });
	}

	if ($ervBody.find('#password-change-required').length) {
		require(['change_password'], function (moduleName) { var requiredClass = new (moduleName); requiredClass.init(); });
	}

	if ($ervBody.find('.highlighttextblock').length) {
		require(['erv_highlight'], function (moduleName) { self.highlight = new (moduleName);	self.highlight.init(); });
	}

    const heroElement = document.querySelector('[data-js=hero-image]')
	if (heroElement) {
		require(['hero_image'], function (moduleName) {
			var HeroImage = new (moduleName)

			HeroImage.init(heroElement)
		});
	}

	if ($('#body.error-page').length) {
		require(['replace'],
			function(moduleName) {
				var requiredClass = new (moduleName);
				requiredClass.init();
			});

		$('body').on('ervDomChanged',
			function() {
				common.init();
				responsive.init();
			});
	} else if ($ervBody.find('.searchpage').length) {
        require(['pagination_simple'],
            function(moduleName) {
                var requiredClass = new (moduleName);
                requiredClass.init(20, '#search-results', '.search-item', '#loadmore');
            });
	} else if (window.requireScripts && window.requireScripts.length > 0) {

		window.requireScripts.forEach(scriptDetails => {

			const [moduleName, initParams] = scriptDetails.split(':');

			if (CHUNKS.includes(moduleName)) {
                return resolveChunk(moduleName);
            }

			if (Object.keys(ModuleRepository).includes(moduleName)) {
                return new ModuleRepository[moduleName]().init(initParams);
            }
        });
    }
});


